<template>
    <div class="about">
        <h1>404</h1>
        <h2>Whoops!</h2>
        <p>
            We couldn't find the page you
            <br/>
            were looking for.
        </p>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    };
</script>

<style lang="sass" scoped>
    .about
        text-align: center
        padding: 20vh 0

        h1
            font-size: 10rem
</style>
